import { render } from "./MonProfil.vue?vue&type=template&id=aac75bf6&scoped=true&ts=true"
import script from "./MonProfil.vue?vue&type=script&lang=ts"
export * from "./MonProfil.vue?vue&type=script&lang=ts"

import "./MonProfil.vue?vue&type=style&index=0&id=aac75bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac75bf6"]])

export default __exports__